import { render, staticRenderFns } from "./top_Footer.vue?vue&type=template&id=fa5b1162&scoped=true&"
import script from "./top_Footer.vue?vue&type=script&lang=js&"
export * from "./top_Footer.vue?vue&type=script&lang=js&"
import style0 from "./top_Footer.vue?vue&type=style&index=0&id=fa5b1162&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5b1162",
  null
  
)

export default component.exports